import React, { useEffect, useState } from 'react';
import WebApp from './web/App';
import MobileApp from './mobile/App';

export default function AppRoot() {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const detect = () => {
      const ua = navigator.userAgent;

      const isTablet =
        /iPad|Tablet|PlayBook/i.test(ua) ||
        (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1); // modern iPadOS

      const isPhone = /Android|iPhone|iPod/i.test(ua);

      const mobile =
        window.innerWidth <= 1024 || // include tablets
        isPhone ||
        isTablet;

      setIsMobile(mobile);
      document.body.classList.toggle('mobile', mobile);
    };

    detect();
    window.addEventListener('resize', detect);
    return () => window.removeEventListener('resize', detect);
  }, []);

  if (isMobile === null) return null;

  return isMobile ? <MobileApp /> : <WebApp />;
}
